import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types';
import { context } from '@adornis/baseql/server/context';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { DateTime } from 'luxon';

@Entity()
export class Publishment extends MongoEntity {
  static override _class = 'Publishment';
  static override _collectionName = 'publishments';

  @validate(nonOptional())
  @Field(type => String)
  entityID!: string;

  @validate(nonOptional())
  @Field(type => String, { default: v => v ?? 'invalid' })
  createdBy!: string;

  @validate(nonOptional())
  @Field(type => DateTime, { default: v => v ?? DateTime.now() })
  createdAt!: DateTime;

  @Field(type => DateTime)
  from?: DateTime;

  @Field(type => DateTime)
  till?: DateTime;

  get isActive(): boolean {
    if (this.from && this.from > DateTime.now()) return false;
    if (this.till && this.till < DateTime.now()) return false;
    return true;
  }

  constructor(data: PartialEntityData<Publishment>) {
    super(data);
  }

  static override async beforeCreate(entity: Publishment): Promise<void> {
    super.beforeCreate(entity);
    if (!context.serverContext) {
      const userID = (await CurrentUserInfo.getCurrentUserInfo()({ userID: 1 })).userID;
      if (!userID) throw new Error("no user on CurrentUserInfo is set. Publishment can't be generated");
      entity.createdBy = userID;
    } else {
      entity.createdBy = 'cronjob';
    }

    entity.createdAt = DateTime.now();
  }
}
